import React from 'react';
import { useLocation } from 'react-router-dom';
import logger from '../services/logger';
import { logLevels, logEvents } from '../constants/appConstants';
import ErrorPage from './Error';

function NotFound() {
    const location = useLocation();

    logger(logLevels.ERROR, {
        source: 'NotFound',
        action: logEvents.REDIRECT,
        payload: {
            Message: 'Route not found',
            Exception: `Route: ${location.pathname} is not defined. Redirecting to 404 status page`,
        },
    });

    return (
        <div>
            <ErrorPage />
            <div
                className="status-text-color kievitlight"
                style={{
                    position: 'absolute',
                    bottom: '10px',
                    right: '10px',
                    fontSize: '30px',
                }}
            >
                404
            </div>
        </div>
    );
}

export default NotFound;
